import { useNavigate } from "react-router-dom";
import { EmptyState } from "../../../../components/empty";
import { BgWrapper } from "../../../../components/wrapper/bgWrapper";

export const ExpiredInvite = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <BgWrapper>
        <EmptyState
          text="Invite has expired"
          className="px-1 pb-3 gap-2"
          textClassName="!normal-case !font-normal !max-w-[380px]"
          subtext="Looks like this invite has expired or was already accepted. Please reach out to the admin for a new one."
          subtextClassName="!max-w-[380px] !text-sm mt-2"
          ctaText="Go Home"
          imageClassName="h-[80px] w-[100px]"
          ctaClassName="!max-w-[380px] mt-2"
          onCTAClick={() => {
            navigate("/");
          }}
          image="/assets/images/invite-expired.svg"
        />
      </BgWrapper>
    </div>
  );
};
